export const EDITABLE_ADMIN_PRIVILEGES = [
    'products', 'product_data', 'reviews', 'coupons', 'promotions', 'doctors',
    'orders', 'shipping', 'banners', 'blog', 'clients', 'contact', 'admins'
];

export const EMPTY_ADMIN_PRIVILEGES = EDITABLE_ADMIN_PRIVILEGES.reduce(
    (privileges, key) => ({ ...privileges, [key]: false }),
    {}
);

export const ADMIN_PRIVILEGE_GROUPS = [
    {
        key: 'product_section',
        label: 'Productos',
        privileges: [
            { key: 'products', label: 'Productos' },
            { key: 'product_data', label: 'Categorías/marca' },
            { key: 'reviews', label: 'Reseñas de productos' },
            { key: 'coupons', label: 'Cupones' },
            { key: 'promotions', label: 'Promociones' }
        ]
    },
    {
        key: 'doctor_section',
        label: 'Médicos',
        privileges: [
            { key: 'doctors', label: 'Alta/listado de médicos' },
            { key: 'doctors', label: 'Pedidos y resumen' },
            { key: 'coupons', label: 'Cupones' }
        ]
    },
    {
        key: 'shop_section',
        label: 'Tienda en línea',
        privileges: [
            { key: 'orders', label: 'Pedidos' },
            { key: 'shipping', label: 'Métodos de envío' },
            { key: 'banners', label: 'Banners' },
            { key: 'blog', label: 'Blog' },
            { key: 'clients', label: 'Clientes' },
            { key: 'contact', label: 'Contacto de clientes' }
        ]
    }
];

export const normalizeAdminPrivileges = privileges => ({
    ...EMPTY_ADMIN_PRIVILEGES,
    ...EDITABLE_ADMIN_PRIVILEGES.reduce((normalized, key) => ({
        ...normalized,
        [key]: privileges?.[key] === true
    }), {})
});

export const getGroupState = (privileges, group) => {
    const keys = [...new Set(group.privileges.map(({ key }) => key))];
    const selected = keys.filter(key => privileges?.[key] === true).length;

    return {
        checked: selected === keys.length,
        indeterminate: selected > 0 && selected < keys.length
    };
};

export const togglePrivilegeGroup = (privileges, group, checked) => {
    const updated = { ...normalizeAdminPrivileges(privileges) };
    group.privileges.forEach(({ key }) => {
        updated[key] = checked;
    });
    return updated;
};
